import { Skeleton } from './skeleton';

export const PageSkeleton = () => {
  return (
    <div className="relative h-full w-full">
      <div className="absolute inset-0 h-full w-full overflow-hidden">
        <div className="h-full w-full bg-background">
          {/* Top ticker bar */}
          <div className="border-b">
            <div className="mx-auto flex h-9 w-full items-center space-x-4 overflow-hidden px-4">
              {Array.from({ length: 12 }).map((_, i) => (
                <div key={i} className="flex items-center space-x-2">
                  <Skeleton className="h-4 w-28" />
                  <Skeleton className="h-4 w-12" />
                </div>
              ))}
            </div>
          </div>

          {/* Header */}
          <div className="border-b">
            <div className="mx-auto flex h-14 w-full items-center justify-between px-4">
              <div className="flex items-center space-x-4">
                <Skeleton className="h-6 w-20" />
                <Skeleton className="h-6 w-12" />
                <Skeleton className="h-6 w-16" />
                <Skeleton className="h-6 w-16" />
                <Skeleton className="h-6 w-12" />
              </div>
              <div className="flex items-center space-x-3">
                <Skeleton className="h-8 w-24" />
                <Skeleton className="h-8 w-28" />
                <Skeleton className="h-8 w-24" />
                <Skeleton className="h-8 w-8 rounded-full" />
              </div>
            </div>
          </div>

          {/* Main layout */}
          <div className="mx-auto flex h-[calc(100vh-9rem)] w-full gap-4 p-4">
            {/* Left sidebar */}
            <div className="hidden h-full w-96 flex-col space-y-4 lg:flex">
              <div className="space-y-3 rounded-md border p-3">
                <Skeleton className="h-4 w-28" />
                <Skeleton className="h-3 w-full" />
                <Skeleton className="h-3 w-5/6" />
                <Skeleton className="h-3 w-2/3" />
                <Skeleton className="h-3 w-1/2" />
              </div>
              <div className="flex-1 rounded-md border p-3">
                <div className="mb-3 flex items-center justify-between">
                  <Skeleton className="h-4 w-24" />
                  <Skeleton className="h-6 w-6" />
                </div>
                <div className="space-y-2">
                  {Array.from({ length: 8 }).map((_, i) => (
                    <div key={i} className="flex items-center justify-between">
                      <Skeleton className="h-4 w-24" />
                      <Skeleton className="h-4 w-12" />
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Chart area - takes remaining space */}
            <div className="h-full flex-1">
              <div className="flex h-full flex-col rounded-md border">
                <div className="flex items-center justify-between border-b px-3 py-2">
                  <div className="flex items-center space-x-2">
                    <Skeleton className="h-6 w-6" />
                    <Skeleton className="h-6 w-6" />
                    <Skeleton className="h-6 w-6" />
                    <Skeleton className="h-6 w-16" />
                    <Skeleton className="h-6 w-16" />
                  </div>
                  <div className="flex items-center space-x-2">
                    <Skeleton className="h-6 w-6" />
                    <Skeleton className="h-6 w-6" />
                  </div>
                </div>
                <div className="w-full flex-1 p-2">
                  <Skeleton className="h-full w-full" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
